import { JournalId, PsychologicalHelpId } from 'types';

export const PSYCHOLOGICAL_HELPS = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/psychologicalHelps`;
export const PSYCHOLOGICAL_HELP = (
    journalId: JournalId,
    psychologicalHelpId: PsychologicalHelpId,
) => `/api/v1/journals/${journalId}/psychologicalHelps/${psychologicalHelpId}`;
